module.exports = __webpack_public_path__ + "media/images/athletes/197-974a92453c0dad55826de59ac378de93.png";